import { createRouter, createWebHashHistory, createWebHistory } from "vue-router";
import Index from "../pages/Index.vue";
import About from "../pages/Info/About.vue";
import Search from "../pages/Info/Search.vue";
import SignUp from "../pages/Info/SignUp.vue";
import CookiePolicy from "../pages/Info/CookiePolicy.vue";
import VendorSignup from "../pages/Info/VendorSignup.vue";
import PrivacyPage from "../pages/Info/PrivacyPolicy.vue";
import TermsPage from "../pages/Info/Terms.vue";
import VendorSelectPage from '@/pages/order/VendorSelectPage.vue';
import VendorPage from '@/pages/order/VendorPage.vue';
import CheckoutPage from '@/pages/order/CheckoutPage.vue';
import OrderCompleteView from '@/pages/order/Complete.vue';
import MyAccountPage from '@/pages/MyAccount/MyAccountPage.vue';
import VerifyEmail from '../pages/VerifyEmail.vue';



const brandMetaTitle = " - Take away near me | Tanm";
const routes = [
  {
    path: "/",
    component: Index,
    name: "Home",
    meta: {
      title: "Home" + brandMetaTitle,
      description: "Find and order from the best local takeaways near you with TANM. Real-time tracking, secure checkout, and fast delivery."
    }
  },
  {
    path: "/about",
    component: About,
    name: "About",
    meta: {
      title: "About" + brandMetaTitle,
      description: "Learn about TANM, our mission to connect you with the best local takeaways, and the team behind the platform."
    }
  },
  ,
  {
    path: "/search",
    component: Search,
    name: "Search",
    meta: {
      title: "Search" + brandMetaTitle,
      description: "Search for takeaways, restaurants, and food near you. Browse menus, compare options, and order in minutes."
    }
  },
  ,
  {
    path: "/sign-up",
    component: SignUp,
    name: "SignUp",
    meta: {
      title: "Sign-up" + brandMetaTitle,
      description: "Create your free TANM account to order food, save your favourite takeaways, and track deliveries in real time."
    }
  },
  , 
  {
    path: '/vendors',
    name: 'Vendors',
    component: VendorSelectPage,
    meta: {
      title: "Vendors" + brandMetaTitle,
      description: "Browse all available takeaways and restaurants near you. Filter by cuisine, rating, and delivery time."
    }
  },
  {
    path: '/restaurant/:slug',
    name: 'VendorPage',
    component: VendorPage,
    meta: {
      title: "Restaurant" + brandMetaTitle,
      description: "View the full menu, opening hours, and reviews. Order for delivery or collection."
    }
  },
  {
    path: '/checkout',
    name: 'Checkout',
    component: CheckoutPage,
    meta: {
      title: "Checkout" + brandMetaTitle,
      description: "Complete your takeaway order with secure payment."
    }
  },
  {
    path: '/order-complete/:orderId',
    name: 'OrderComplete',
    component: OrderCompleteView,
    props: true,
    meta: {
      title: "Order Complete" + brandMetaTitle,
      description: "Your order has been placed. Track your delivery in real time."
    }
  },
  {
    path: "/cookie-policy",
    component: CookiePolicy,
    name: "Cookie Policy",
    meta: {
      title: "Cookie Policy" + brandMetaTitle,
      description: "Learn how TANM uses cookies to improve your experience and keep our platform running smoothly."
    }
  },
  {
    path: "/vendor-signup",
    component: VendorSignup,
    name: "Vendor Signup",
    meta: {
      title: "Vendor Signup" + brandMetaTitle,
      description: "Register your restaurant or takeaway on TANM. Reach more local customers and manage orders easily."
    }
  },
  {
    path: '/myaccount',
    name: 'MyAccount',
    component: MyAccountPage,
    meta: {
      title: "My Account" + brandMetaTitle,
      description: "Manage your TANM account, view order history, and update your details."
    }
  },

  {
    path: '/privacy',
    name: 'Privacy',
    component: PrivacyPage,
    meta: {
      title: "Privacy Policy" + brandMetaTitle,
      description: "Read how TANM collects, uses, and protects your personal data."
    }
  },

  {
    path: '/terms',
    name: 'Terms',
    component: TermsPage,
    meta: {
      title: "Terms & Conditions" + brandMetaTitle,
      description: "Review the terms and conditions for using the TANM platform."
    }
  },
  {
    path: "/verify-email",
    name: "Verify Email",
    component: VerifyEmail,
    meta: {
      title: "Verify Email" + brandMetaTitle,
      description: "Verify your email address to activate your TANM account."
    }
  }  
];

const isCapacitor = !!window.Capacitor;


const router = createRouter({
  history: isCapacitor ? createWebHashHistory() : createWebHistory(),
  routes,
});

export default router;
